import RecordOutcomeDialog from "../Challenge/RecordOutcomeDialog";

// Verification-stage determination (V10.1) — EcoChallenge.recordOutcome, replacing
// EcoBank.judgeTermFraud(tokenId, upheld). Kept as a named wrapper so CovenantChallengePanel's
// import and props are unchanged; the dialog is shared with the deed stage in
// components/Challenge/RecordOutcomeDialog.tsx.
//
// The V9 "inverted polarity" this file used to warn about is gone: both stages record the same
// two booleans (upheld governs the verifier, inBreach governs the covenant) and the contract
// derives the consequences. A frozen drip is no longer thawed by a second verdict — only a real
// re-verification, followed by releaseAfterReVerification, unfreezes it.

export interface JudgeTermChallengeDialogProps {
  open: boolean;
  onClose: () => void;
  // On-chain token id.
  tokenId: number | string;
  // Connected wallet — the dialog says whether it holds a seat on the drawn panel.
  viewerAddress?: string | null;
  // Called once the determination is mined, so the caller can re-read.
  onJudged?: (upheld: boolean) => void;
}

const JudgeTermChallengeDialog = ({
  open,
  onClose,
  tokenId,
  viewerAddress,
  onJudged,
}: JudgeTermChallengeDialogProps) => (
  <RecordOutcomeDialog
    open={open}
    onClose={onClose}
    stage="verification"
    tokenId={tokenId}
    viewerAddress={viewerAddress}
    onJudged={(upheld) => onJudged?.(upheld)}
  />
);

export default JudgeTermChallengeDialog;
